/**
 * @fileoverview Agent definition for generate-world-element-portrait-v2.
 *
 * Composite agent that orchestrates the full world element portrait generation:
 * prompt creation → FAL.ai image generation.
 *
 * @category visuals.portraits.world-building
 * @type composite
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'generate-world-element-portrait-v2',
  kind: 'composite',
  name: 'Generate World Element Portrait',
  description: 'Generates a portrait image for a world element (place, set, object, species) by creating an optimized prompt and then generating the image via FAL.ai.',
  category: 'visuals',
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata ---
  metadata: {
    status: 'active',
    type: 'composite',
    addedIn: '2026-03',
    lastUpdated: '2026-03',
    taxonomyPath: 'visuals.portraits.world-building',
    usedBy: [],
    composedOf: [
      'world-element-image-prompt-creator-v2',
      'world-element-image-creator-fal-v2',
    ],
    relatedAgents: [
      'world-element-image-prompt-creator-v2',
      'world-element-image-creator-fal-v2',
      'portrait-image-prompt-creator-v2',
      'portrait-image-creator-fal-v2',
    ],
  },
};
